<div class="ui-checklist__group-fields" [ui-loading]="loading">
    @if (!loading) {
        <h3 class="ui-checklist__group-fields__header"
            [ngClass]="{'underline-animation': animateUnderline}">
            {{ preenchimento?._campo?.titulo }}
        </h3>
        <hr>
        <!-- ESTRUTURA-->
        @for (e of preenchimento?._campo?.estrutura; track e; let i = $index) {

            <div class="ui-checklist__group-fields__field">
                <div class="ui-checklist__group-fields__field-title">
                    {{ i + 1 }} . {{ e.nome }}

                    @if (!e.opcional) {
                        <span class="text-feedback-danger">*</span>
                    }

                    @if (e.texto_associado) {
                        <ui-button
                            variant="link"
                            (click)="openInfo(e.texto_associado)"
                        >
                            <i class="fa fa-info"></i>
                        </ui-button>
                    }
                </div>

                <div class="ui-checklist__group-fields__fields-input">
                    @switch (e.tipo) {
                        @case ('gps') {
                            <div class="d-flex gap-10 align-items-center justify-content-center">
                                <app-material-input class="flex-2" label="Latitude">
                                    <input type="text" [(ngModel)]="preenchimento.dados[i].valor.lat"
                                           mask="-00.0000000"
                                           [dropSpecialCharacters]="false"
                                    >
                                </app-material-input>
                                <app-material-input class="flex-2" label="Longitude">
                                    <input type="text" [(ngModel)]="preenchimento.dados[i].valor.lng"
                                           mask="-00.0000000"
                                           [dropSpecialCharacters]="false"
                                    >
                                </app-material-input>
                                <app-material-input class="flex-1" label="Acurácia">
                                    <input type="text" [(ngModel)]="preenchimento.dados[i].valor.acc">
                                </app-material-input>
                                <ui-button
                                    color="secondary"
                                    variant="outline"
                                    (click)="getCurrentLocation(preenchimento, i)"
                                >
                                    <i class="fa fa-map-marker-alt"></i> Atual
                                </ui-button>
                            </div>
                        }
                        @case ('listaFixa') {
                            <ui-checklist-list-field
                                [data]="preenchimento.dados[i]"
                                [group]="preenchimento._campo"
                                [field]="e"
                                [triggers]="triggers"
                                (groupTriggerChange)="openConditionalModal($event)"
                            ></ui-checklist-list-field>
                        }
                        @case ('listaMultipla') {
                            <ui-checklist-list-field
                                [data]="preenchimento.dados[i]"
                                [group]="preenchimento._campo"
                                [field]="e"
                                [triggers]="triggers"
                                (groupTriggerChange)="openConditionalModal($event)"
                            ></ui-checklist-list-field>
                        }
                        @case ('verdadeiroFalso') {
                            <ui-checklist-boolean-field
                                [data]="preenchimento.dados[i]"
                                [group]="preenchimento._campo"
                                [field]="e"
                                [triggers]="triggers"
                                (groupTriggerChange)="openConditionalModal($event)"
                            ></ui-checklist-boolean-field>
                        }
                        @case ('numero') {
                            <app-material-input [required]="!e.opcional">
                                <input type="number" [(ngModel)]="preenchimento.dados[i].valor">
                            </app-material-input>
                        }
                        @case ('texto') {
                            <app-material-input [required]="!e.opcional">
                                <input type="text" [(ngModel)]="preenchimento.dados[i].valor">
                            </app-material-input>
                        }
                        @case ('textArea') {
                            <app-material-input class="col">
                                <textarea
                                    [(ngModel)]="preenchimento.dados[i].valor">
                                </textarea>
                            </app-material-input>
                        }
                        @case ('dataHora') {
                            <app-material-input class="col-4" [required]="!e.opcional">
                                <input
                                    type="datetime-local"
                                    [(ngModel)]="preenchimento.dados[i].valor"
                                >
                            </app-material-input>
                        }
                        @case ('assinaturaFormulario') {
                            <ui-checklist-signature-field
                                [data]="preenchimento.dados[i]"
                                [required]="!e.opcional"
                            ></ui-checklist-signature-field>
                        }
                        @case ('video') {
                            @if (isEdit && preenchimento.dados[i].valor) {
                                <ui-alert variant="success" label="Upload realizado com sucesso!">
                                    <div class="d-flex gap-20 align-items-center justify-content-center">
                                        <div class="flex-1">
                                            O upload do arquivo <b>{{ getFileName(preenchimento.dados[i].valor) }}</b> foi realizado com sucesso!
                                        </div>

                                        <ui-button variant="link" color="danger" (click)="preenchimento.dados[i].valor = null">
                                            <i class="fa fa-trash"></i> Remover
                                        </ui-button>
                                    </div>
                                </ui-alert>
                            } @else {
                                <ui-card variant="internal" display="full-space" behaviour="multiple">
                                    <app-upload-files
                                        [extensoesPermitidas]="['mp4', 'mov', 'avi']"
                                        [maxArquivos]="1"
                                        [tamanhoMaximoPorArquivo]="1024 * 1024 * 10"
                                        (onEmitFiles)="selectImg(i, $event, 'video')"
                                    ></app-upload-files>
                                </ui-card>
                            }
                        }
                        @case ('foto') {
                            @if (isEdit && preenchimento.dados[i].valor) {
                                <ui-alert variant="success" label="Upload realizado com sucesso!">
                                    <div class="d-flex gap-20 align-items-center justify-content-center">
                                        <div class="flex-1">
                                            O upload da foto <b>{{ getFileName(preenchimento.dados[i].valor) }}</b> foi realizado com sucesso!
                                        </div>

                                        <ui-button variant="link" color="danger" (click)="preenchimento.dados[i].valor = null">
                                            <i class="fa fa-trash"></i> Remover
                                        </ui-button>
                                    </div>
                                </ui-alert>
                            } @else {
                                <ui-card variant="internal" display="full-space" behaviour="multiple">
                                    <app-upload-files
                                        [extensoesPermitidas]="['png', 'jpg', 'jpeg']"
                                        [maxArquivos]="1"
                                        [tamanhoMaximoPorArquivo]="1024 * 1024 * 10"
                                        (onEmitFiles)="selectImg(i, $event, 'foto')"
                                    ></app-upload-files>
                                </ui-card>
                            }
                        }
                        @case ('pdf') {
                            @if (isEdit && preenchimento.dados[i].valor) {
                                <ui-alert variant="success" label="Upload realizado com sucesso!">
                                    <div class="d-flex gap-20 align-items-center justify-content-center">
                                        <div class="flex-1">
                                            O upload do documento <b>{{ getFileName(preenchimento.dados[i].valor) }}</b> foi realizado com sucesso!
                                        </div>

                                        <ui-button variant="link" color="danger" (click)="preenchimento.dados[i].valor = null">
                                            <i class="fa fa-trash"></i> Remover
                                        </ui-button>
                                    </div>
                                </ui-alert>
                            } @else {
                                <ui-card variant="internal" display="full-space" behaviour="multiple">
                                    <app-upload-files
                                        [extensoesPermitidas]="['pdf']"
                                        [maxArquivos]="1"
                                        [tamanhoMaximoPorArquivo]="1024 * 1024 * 10"
                                        (onEmitFiles)="selectImg(i, $event, 'pdf')"
                                    ></app-upload-files>
                                </ui-card>
                            }
                        }
                    }
                </div>
            </div>
        }
    }
</div>

<ui-modal
    height="100%"
    width="100%"
    (close)="rollbackCond()"
>
    <i modalIcon class="text-brand-secondary {{FORM_ITEM_PROPS[FormItemType.CONDITIONAL_GROUP].icon}}"></i>
    <h3 modalTitle>{{ preenchimentoCondicional?._campo?.titulo.toLocaleUpperCase () }}</h3>
    <h4 modalSubtitle>
        Preencha todas as informações solicitadas no grupo condicional.<b>Campos marcados com
        <span class="text-feedback-danger">*</span></b> são obrigatórios!
    </h4>
    <ui-card modalContent variant="internal" shape="square">
        @for (est of preenchimentoCondicional?._campo?.estrutura; track est; let i = $index) {
            <div class="ui-checklist__group-fields__field">
                <div class="ui-checklist__group-fields__field-title">
                    {{ i + 1 }} . {{ est.nome }}

                    @if (!est.opcional) {
                        <span class="text-feedback-danger">*</span>
                    }

                    @if (est.texto_associado) {
                        <ui-button
                            variant="link"
                            (click)="openInfo(est.texto_associado)"
                        >
                            <i class="fa fa-info"></i>
                        </ui-button>
                    }
                </div>

                <div class="ui-checklist__group-fields__fields-input">
                    @switch (est.tipo) {
                        @case ('gps') {
                            <div class="d-flex gap-10 align-items-center justify-content-center">
                                <app-material-input class="flex-2" label="Latitude">
                                    <input type="text" [(ngModel)]="preenchimentoCondicional.dados[i].valor.lat"
                                           mask="-00.0000000"
                                           [dropSpecialCharacters]="false"
                                    >
                                </app-material-input>
                                <app-material-input class="flex-2" label="Longitude">
                                    <input type="text" [(ngModel)]="preenchimentoCondicional.dados[i].valor.lng"
                                           mask="-00.0000000"
                                           [dropSpecialCharacters]="false"
                                    >
                                </app-material-input>
                                <app-material-input class="flex-1" label="Acurácia">
                                    <input type="text" [(ngModel)]="preenchimentoCondicional.dados[i].valor.acc">
                                </app-material-input>
                                <ui-button
                                    color="secondary"
                                    variant="outline"
                                    (click)="getCurrentLocation(preenchimentoCondicional, i)"
                                >
                                    <i class="fa fa-map-marker-alt"></i> Atual
                                </ui-button>
                            </div>
                        }
                        @case ('listaFixa') {
                            <ui-checklist-list-field
                                [data]="preenchimentoCondicional.dados[i]"
                                [group]="preenchimentoCondicional._campo"
                                [field]="est"
                                [triggers]="triggers"
                            ></ui-checklist-list-field>
                        }
                        @case ('listaMultipla') {
                            <ui-checklist-list-field
                                [data]="preenchimentoCondicional.dados[i]"
                                [group]="preenchimentoCondicional._campo"
                                [field]="est"
                                [triggers]="triggers"
                            ></ui-checklist-list-field>
                        }
                        @case ('verdadeiroFalso') {
                            <ui-checklist-boolean-field
                                [data]="preenchimentoCondicional.dados[i]"
                                [group]="preenchimentoCondicional._campo"
                                [field]="est"
                                [triggers]="triggers"
                            ></ui-checklist-boolean-field>
                        }
                        @case ('numero') {
                            <app-material-input [required]="!est.opcional">
                                <input type="number" [(ngModel)]="preenchimentoCondicional.dados[i].valor">
                            </app-material-input>
                        }
                        @case ('texto') {
                            <app-material-input [required]="!est.opcional">
                                <input type="text" [(ngModel)]="preenchimentoCondicional.dados[i].valor">
                            </app-material-input>
                        }
                        @case ('textArea') {
                            <app-material-input class="col">
                                <textarea
                                    [(ngModel)]="preenchimentoCondicional.dados[i].valor">
                                </textarea>
                            </app-material-input>
                        }
                        @case ('dataHora') {
                            <app-material-input class="col-4" [required]="!est.opcional">
                                <input
                                    type="datetime-local"
                                    [(ngModel)]="preenchimentoCondicional.dados[i].valor"
                                >
                            </app-material-input>
                        }
                        @case ('assinaturaFormulario') {
                            <ui-checklist-signature-field
                                [data]="preenchimentoCondicional.dados[i]"
                                [required]="!est.opcional"
                            ></ui-checklist-signature-field>
                        }
                        @case ('video') {
                            @if (isEdit && preenchimentoCondicional.dados[i].valor) {
                                <ui-alert variant="success" label="Upload realizado com sucesso!">
                                    <div class="d-flex gap-20 align-items-center justify-content-center">
                                        <div class="flex-1">
                                            O upload do arquivo <b>{{ getFileName(preenchimentoCondicional.dados[i].valor) }}</b> foi realizado com sucesso!
                                        </div>

                                        <ui-button variant="link" color="danger" (click)="preenchimentoCondicional.dados[i].valor = null">
                                            <i class="fa fa-trash"></i> Remover
                                        </ui-button>
                                    </div>
                                </ui-alert>
                            } @else {
                                <ui-card variant="internal" display="full-space" behaviour="multiple">
                                    <app-upload-files
                                        [extensoesPermitidas]="['mp4', 'mov', 'avi']"
                                        [maxArquivos]="1"
                                        [tamanhoMaximoPorArquivo]="1024 * 1024 * 10"
                                        (onEmitFiles)="selectFileCond(i, $event, preenchimentoCondicional, 'video')"
                                    ></app-upload-files>
                                </ui-card>
                            }
                        }
                        @case ('foto') {
                            @if (isEdit && preenchimentoCondicional.dados[i].valor) {
                                <ui-alert variant="success" label="Upload realizado com sucesso!">
                                    <div class="d-flex gap-20 align-items-center justify-content-center">
                                        <div class="flex-1">
                                            O upload da foto <b>{{ getFileName(preenchimentoCondicional.dados[i].valor) }}</b> foi realizado com sucesso!
                                        </div>
                                        <ui-button variant="link" color="danger" (click)="preenchimentoCondicional.dados[i].valor = null">
                                            <i class="fa fa-trash"></i> Remover
                                        </ui-button>
                                    </div>
                                </ui-alert>
                            } @else {
                                <ui-card variant="internal" display="full-space" behaviour="multiple">
                                    <app-upload-files
                                        [extensoesPermitidas]="['png', 'jpg', 'jpeg']"
                                        [maxArquivos]="1"
                                        [tamanhoMaximoPorArquivo]="1024 * 1024 * 10"
                                        (onEmitFiles)="selectFileCond(i, $event, preenchimentoCondicional, 'foto')"
                                    ></app-upload-files>
                                </ui-card>
                            }
                        }
                        @case ('pdf') {
                            @if (isEdit && preenchimentoCondicional.dados[i].valor) {
                                <ui-alert variant="success" label="Upload realizado com sucesso!">
                                    <div class="d-flex gap-20 align-items-center justify-content-center">
                                        <div class="flex-1">
                                            O upload do documento <b>{{ getFileName(preenchimentoCondicional.dados[i].valor) }}</b> foi realizado com sucesso!
                                        </div>
                                        <ui-button variant="link" color="danger" (click)="preenchimentoCondicional.dados[i].valor = null">
                                            <i class="fa fa-trash"></i> Remover
                                        </ui-button>
                                    </div>
                                </ui-alert>
                            } @else {
                                <ui-card variant="internal" display="full-space" behaviour="multiple">
                                    <app-upload-files
                                        [extensoesPermitidas]="['pdf']"
                                        [maxArquivos]="1"
                                        [tamanhoMaximoPorArquivo]="1024 * 1024 * 10"
                                        (onEmitFiles)="selectFileCond(i, $event, preenchimentoCondicional, 'pdf')"
                                    ></app-upload-files>
                                </ui-card>
                            }
                        }
                    }
                </div>
            </div>
        }
    </ui-card>

    <ui-button modalAction width="full-space" variant="outline" modal-toggle>
        Cancelar
    </ui-button>

    <ui-button modalAction width="full-space" (click)="saveCondicional()">
        Salvar
    </ui-button>
</ui-modal>

